// SINGLE EXHIBITION COMPONENT, USED IN ExhibitionList.js

import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "./../language-context";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { css } from "styled-components";
import { pl } from "./../data/pl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { RiArrowLeftSFill } from "react-icons/ri";

const marginBottom = css`
  margin-bottom: 1rem;
`;

const ExhbitionItem = styled.article`
  ${variables.Flex};
  ${variables.DimensionsView};
  padding: 0 2rem;
  background-color: ${variables.BACKGROUND_GRAY};

  @media (max-width: 1000px) {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    height: auto;
    padding: 5rem 2rem;
  }
`;

const ExhibitionData = styled.div`
  width: 80%;
  opacity: 0;
  animation: ${variables.ChangeOpacity} 0.5s 1.5s linear forwards;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const ExhibitionPoster = styled(LazyLoadImage)`
  width: 20%;
  height: auto;
  margin-left: 2rem;
  opacity: 0;
  animation: ${variables.ChangeOpacity} 0.5s 0.1s linear forwards;

  @media (max-width: 1000px) {
    width: auto;
    max-width: 100%;
    max-height: 60%;
    margin-left: 0;
    margin-bottom: 2rem;
  }
`;

const ExhibitionTitle = styled.h2`
  ${marginBottom}
  font-size: ${variables.TITLE_FONT};

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.REGULAR_FONT};
  }
`;

const ExhibitionDate = styled.h3`
  ${marginBottom}

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.MOBILE_FONT};
  }
`;

const ExhibitionDescription = styled.p`
  ${marginBottom}

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.MOBILE_FONT};
  }
`;

const ExhibitionLink = styled.a`
  color: ${variables.DARK};
  font-size: ${variables.MOBILE_FONT};
  display: block;
  text-decoration: none;

  &:hover {
    font-weight: 900;
  }

  &:visited {
    color: ${variables.DARK};
  }

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.SMALL_MOBILE_FONT};
  }
`;

const BackButton = styled(Link)`
  display: block;
  padding: 1.5rem 0;
  text-decoration: none;
  color: ${variables.DARK};
  font-size: ${variables.REGULAR_FONT};
  font-weight: 600;
`;

export const Exhibition = ({ exhibitionId }) => {
  const usedLanguage = useContext(LanguageContext);

  const { exhibitionTitle, exhibitionDate, exhibitionDescription } =
    usedLanguage.language.exhibitions.exhibitionsContainer[exhibitionId];

  const { exhibitionLink1, exhibitionLink2, exhibitionLink3, exhibitionImage } =
    pl.exhibitions.exhibitionsContainer[exhibitionId]; //pl because this data is the same no matter the language

  const { backToExhibitionsPage } = usedLanguage.language.menu;

  // eslint-disable-next-line
  const [isList, setIsList] = useState(
    /^\d{4}$/.test(window.location.href.slice(-4)) === true ? false : true
  );

  return isList ? (
    <ExhbitionItem>
      <ExhibitionData>
        <ExhibitionTitle>{exhibitionTitle}</ExhibitionTitle>
        <ExhibitionDate>{exhibitionDate}</ExhibitionDate>
      </ExhibitionData>
      <ExhibitionPoster
        src={exhibitionImage}
        alt={`${exhibitionTitle} - Michał Król - Structuralist`}
      />
    </ExhbitionItem>
  ) : (
    <ExhbitionItem>
      <ExhibitionData>
        <BackButton to={"/exhibitions"}>
          <RiArrowLeftSFill
            style={{ fontSize: "1.5rem", position: "relative", top: ".25rem" }}
          />
          {backToExhibitionsPage}
        </BackButton>
        <ExhibitionTitle>{exhibitionTitle}</ExhibitionTitle>
        <ExhibitionDate>{exhibitionDate}</ExhibitionDate>
        <ExhibitionDescription>{exhibitionDescription}</ExhibitionDescription>
        <ExhibitionLink href={exhibitionLink1}>
          {exhibitionLink1}
        </ExhibitionLink>
        <ExhibitionLink href={exhibitionLink2}>
          {exhibitionLink2}
        </ExhibitionLink>
        <ExhibitionLink href={exhibitionLink3}>
          {exhibitionLink3}
        </ExhibitionLink>
      </ExhibitionData>
      <ExhibitionPoster
        src={exhibitionImage}
        alt={`${exhibitionTitle} - Michał Król - Structuralist`}
      />
    </ExhbitionItem>
  );
};
